<template>
  <div class="reviews slider" :class="{ dark }">
    <h3 class="h2">
      {{ $c.text('components.reviews.title') }}
    </h3>
    <SlidingAnimation class="reviews-animation" horizontal>
      <div>
        <div class="row">
          <div v-for="(review, idx) in reviews[$config.platform].row1" :key="idx" class="col">
            <div class="review">
              <div class="body">
                <Rating :scale="review.rating" />
                <div class="body-2">
                  {{ review.text }}
                </div>
              </div>
              <div class="info">
                <img loading="lazy" :src="`${$config.imagesUrl}/reviews/${review.image}`" :alt="review.name">
                <div>
                  <div class="name" :class="{ 'fa': $config.platform === 'fa' }">
                    {{ review.name }}
                    <Check />
                  </div>
                  {{ review.country }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div v-for="(review, idx) in reviews[$config.platform].row2" :key="idx" class="col">
            <div class="review">
              <div class="body">
                <Rating :scale="review.rating" />
                <div class="body-2">
                  {{ review.text }}
                </div>
              </div>
              <div class="info">
                <img loading="lazy" :src="`${$config.imagesUrl}/reviews/${review.image}`" :alt="review.name">
                <div>
                  <div class="name" :class="{ 'fa': $config.platform === 'fa' }">
                    {{ review.name }}
                    <Check />
                  </div>
                  {{ review.country }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="row">
          <div v-for="(review, idx) in reviews[$config.platform].row1" :key="idx" class="col">
            <div class="review">
              <div class="body">
                <Rating :scale="review.rating" />
                <div class="body-2">
                  {{ review.text }}
                </div>
              </div>
              <div class="info">
                <img loading="lazy" :src="`${$config.imagesUrl}/reviews/${review.image}`" :alt="review.name">
                <div>
                  <div class="name" :class="{ 'fa': $config.platform === 'fa' }">
                    {{ review.name }}
                    <Check />
                  </div>
                  {{ review.country }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div v-for="(review, idx) in reviews[$config.platform].row2" :key="idx" class="col">
            <div class="review">
              <div class="body">
                <Rating :scale="review.rating" />
                <div class="body-2">
                  {{ review.text }}
                </div>
              </div>
              <div class="info">
                <img loading="lazy" :src="`${$config.imagesUrl}/reviews/${review.image}`" :alt="review.name">
                <div>
                  <div class="name" :class="{ 'fa': $config.platform === 'fa' }">
                    {{ review.name }}
                    <Check />
                  </div>
                  {{ review.country }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SlidingAnimation>
  </div>
</template>
<script>
import SlidingAnimation from './Animations/Sliding';
import Rating from './Rating';
import Check from '../assets/svg/icon-check-circle.svg?vue-component';

const reviews = {
  ds: {
    row1: [
      {
        text: 'The 365 Data Science program has exceeded my expectations. All of the courses I’ve completed to date have been taught by very knowledgeable instructors. I just completed the Python course. It was very well structured and...',
        name: 'Rachid Drissi',
        country: 'United States',
        rating: 5,
        image: 'Rachid Drissi.jpg',
      },
      {
        text: 'For a busy professional like myself, I usually don’t have time to read books. 365 Data Science seemed to spend a lot of time tailoring videos that can easily be followed... Videos are short and concise, but very informative.',
        name: 'Mounir',
        country: 'Pakistan',
        rating: 5,
        image: 'Mounir.jpg',
      },
      {
        text: 'I just completed the first course in the 365 Data Science Program. I must say, it’s an excellent course with great insight and well-structured infographic, putting all concept at a glance. I can’t wait to get through other courses and modules...',
        name: 'Ndubuisi Nwabueze',
        country: 'Nigeria',
        rating: 5,
        image: 'Ndubuisi Nwabueze.jpg',
      },
      {
        text: '365 Data Science is really great for learning essential skills and knowledge in every aspect of data science. The time for every session is short and you can easily complete it, and continue to learn or solve the exercises.',
        name: 'mahsa choop',
        country: 'United States',
        rating: 4,
        image: 'mahsa choop.jpg',
      },
      {
        text: '💯% Excellent in all aspects of teaching. The Lectures are easy to understand, and the site is easy to access and very user-friendly. I will forever be grateful for the opportunity given to me during the COVID-19 crisis. Thanks 365DataScience',
        name: 'Ajeigbe Abdulhakeem Bolaji',
        country: 'Algeria',
        rating: 5,
        image: 'Ajeigbe Abdulhakeem Bolaji.jpg',
      },
      {
        text: 'The Data Science world is overwhelming if you are a total beginner. I just have medium-advanced knowledge in Excel and the intro to Data and Data Science Module is really great. Thoroughly explained, made simple, and giving me...',
        name: 'José Maria Robles Alvarez',
        country: 'Spain',
        rating: 5,
        image: 'José Maria Robles Alvarez.jpg',
      },
      {
        text: 'The course is well-structured and organized. Got me hooked without any repetitive and irrelevant information. Hoping to finish this as soon as possible.',
        name: 'Sathyanarayanan Srinivasan',
        country: 'India',
        rating: 5,
        image: 'Sathyanarayanan Srinivasan.jpg',
      },
      {
        text: 'Worth every penny! I knew barely anything about data science before this course, and now I am confident in my skills. There are many sections on different topics - from the very basics to advanced things. By the time of compl...',
        name: 'Stas Popov',
        country: 'Russia',
        rating: 5,
        image: 'Stas Popov.jpg',
      },
      {
        text: 'The materials are well-presented and well-prepared. Very good learning programs, highly recommended for those who want to study a subject in data analysis/science. I have subscribed to the website and it is worth every cent.',
        name: 'Anton',
        country: 'Russia',
        rating: 5,
        image: 'Anton.jpg',
      },
      {
        text: 'This course stands out as Excellent. As an HR Professional who wants to major in Analytics, I found the learning experience so exciting. The instructor made learning fun! I will recommend this to everyone out there.',
        name: 'Oyesina Victor Akingboye',
        country: 'France',
        rating: 5,
        image: 'Oyesina Victor Akingboye.jpg',
      },
      {
        text: 'The best Data Science online platform, with lots of useful and valuable topics. Highly Recommended for Everyone!!!',
        name: 'Davit Bolkvadze',
        country: 'Georgia',
        rating: 5,
        image: 'Davit Bolkvadze.jpg',
      },
      {
        text: '365 Data Science gives the best data science courses out there! It’s really helpful, the videos come with exercise files and quizzes to test your skills at each module, to determine your level. You can learn at your own pace. Also, t...',
        name: 'Amin Bt',
        country: 'Turkey',
        rating: 5,
        image: 'Amin Bt.jpg',
      },
      {
        text: 'I am a beginner in programming and have used 365 Data Science and, speaking for myself, the progress I have made so far is incredible. I can now code ML related stuff. Unthinkable for a guy with no background in computer scienc...',
        name: 'Nabil Mahamad Hanif',
        country: 'India',
        rating: 5,
        image: 'Nabil Mahamad Hanif.jpg',
      },
      {
        text: 'The videos are very well explained and also equipped with various exercises and solutions. The videos start at a beginner level and go on to teach advanced topics as well, but are quite easy to understand.',
        name: 'Monil Shah',
        country: 'India',
        rating: 5,
        image: 'Monil Shah.jpg',
      },
      {
        text: 'I absolutely enjoyed the 365 Data Science learning platform. It has the best courses to begin your Data Science journey. Each concept is explained to perfection.',
        name: 'Adit Khandelwal',
        country: 'Pakistan',
        rating: 5,
        image: 'Adit Khandelwal.jpg',
      },
      {
        text: 'The whole program is very student friendly. With the proper routine and solid goal, anyone, regardless of his background, can easily start his data science journey. It\'s better to follow the sequence which has been organized in ...',
        name: 'akib khan',
        country: 'United Arab Emirates',
        rating: 5,
        image: 'akib khan.jpg',
      },
      {
        text: 'To be honest, 365 Data Science is one of the best platforms where you can explore and learn a lot. It is a place where you will gain a lot of knowledge and will also understand each and everything explained in the course. Plus...',
        name: 'Priya Pandey',
        country: 'India',
        rating: 5,
        image: 'Priya Pandey.jpg',
      },
      {
        text: 'Excellent courses, excellent instructors, and overall a great experience. I learned a great deal from these courses.',
        name: 'Klodian Xhini',
        country: 'United Kingdom',
        rating: 5,
        image: 'Klodian Xhini.jpg',
      },
      {
        text: 'Thank you so much 365 Data Science for your amazing courses! They are really helping me grow and learn new things, and they are quite accurate and easy to understand. And I want to mention your instructors are also aweso...',
        name: 'shivam verma',
        country: 'India',
        rating: 5,
        image: 'shivam verma.jpg',
      },
      {
        text: 'As a passionate learner of Data Science, I would recommend 365 Data Science any time to all other aspiring Data Scientists – even to other beginners who would like to have a glimpse of the science in a professional, painless route.',
        name: 'Gehad mohammed',
        country: 'Pakistan',
        rating: 5,
        image: 'Gehad mohammed.jpg',
      },
    ],
    row2: [
      {
        text: 'The 365 Data Science Program is mind-blowing if you are new to the Data Science field and eager to learn the basics. It lays a great foundation to your knowledge on Data Science. The stuff they explain in the intro course is a grea...',
        name: 'Vikesh Reddy Nallamilli',
        country: 'India',
        rating: 5,
        image: 'Vikesh Reddy Nallamilli.jpg',
      },
      {
        text: '365 Data Science is one of the best resources to learn the concepts and tools to become an aspiring data scientist. I would recommend it to any beginner.',
        name: 'Maher Nabeel',
        country: 'United Arab Emirates',
        rating: 5,
        image: 'Maher Nabeel.jpg',
      },
      {
        text: 'Browsing through lots of other courses, I was greatly surprised by the whole online learning platform package for Data Science. Well-structured courses, engaging and interesting content, and holistic approach to each and every as...',
        name: 'Rashmi Gakhar',
        country: 'Pakistan',
        rating: 5,
        image: 'Rashmi Gakhar.jpg',
      },
      {
        text: 'So, I was searching for quality, well-organized contents for Data Science. After looking at many sites, I finally ended up on the 365 Data Science website. Guys, believe me, I have never seen any course build-up this wel...',
        name: 'Ahmad Zakaria',
        country: 'Germany',
        rating: 5,
        image: 'Ahmad Zakaria.jpg',
      },
      {
        text: 'The 365 Data Science program is great for beginners. It gives in-depth knowledge and clears every concept. After every lecture, some exercises are given for students to complete for practice, and solutions also. I would hig...',
        name: 'harshita sharma',
        country: 'Pakistan',
        rating: 5,
        image: 'harshita sharma.jpg',
      },
      {
        text: '365 Data Science is an amazing platform and I would recommend it to everyone who wish to start his/her journey in Data Science field. You don\'t need any prerequisites, you only need good internet connection and curiosity...',
        name: 'anuj gupta',
        country: 'India',
        rating: 5,
        image: 'anuj gupta.jpg',
      },
      {
        text: 'I found this program to be very well structured. You have everything you need to start in the data science field, very well explained and with excellent exercises for one to practice. You will not only not get bored at all, but you will als...',
        name: 'Rodrigo Mendizabal',
        country: 'Spain',
        rating: 5,
        image: 'Rodrigo Mendizabal.jpg',
      },
      {
        text: 'The 365 Data Science course is outstanding, it has an outstanding interface and awesome courses from a basic to an advanced level. I really appreciate the quality of the material and the content of this Data Science c...',
        name: 'Rakesh Patel',
        country: 'United States',
        rating: 5,
        image: 'Rakesh Patel.jpg',
      },
      {
        text: 'The 365 Data Science program is as good as it gets. It builds your concepts from scratch all the way to a professional level. The program is rigorous in both its explanations and the exercises. The instructors are well-experienced, and th...',
        name: 'DivS',
        country: 'Belgium',
        rating: 5,
        image: 'DivS.jpg',
      },
      {
        text: '365 Data Science courses are truly amazing. They help you build the basic understanding of data science and then lead you to be a professional in any data science field.',
        name: 'Muhammad Anique',
        rating: 5,
        country: 'India',
        image: 'Muhammad Anique.jpg',
      },
      {
        text: 'I highly recommend 365DataScience for the quality of the videos and the well-structured courses. I like the organized content in the courses and the up-to-date info you offer, such as R programming, Python, Statistics, and so...',
        name: 'Girish Kulkarni',
        country: 'United States',
        rating: 5,
        image: 'Girish Kulkarni.jpg',
      },
      {
        text: 'I liked the whole program and found it very helpful to me as an enthusiast programmer. The course takes you in a steady progression from the fundamentals to the advanced without getting lost. The program centers...',
        name: 'Mohamad Eido',
        country: 'Nigeria',
        rating: 5,
        image: 'Mohamad Eido.jpg',
      },
      {
        text: 'I was looking for a complete package for learning Data Science from scratch to an advanced level, but had not found any suitable one. In my quarantine days, while googling, I found this tremendous bundle of Data Science courses where...',
        name: 'Monira Akter Laboni',
        country: 'India',
        rating: 5,
        image: 'Monira Akter Laboni.jpg',
      },
      {
        text: 'I recommend this program to anyone since it is a single platform that teaches everything in a logical order without losing your attention and interest. This program covers the skills related to each step - data collection, analysis & modeli...',
        name: 'Shovkat',
        rating: 5,
        country: 'Turkey',
        image: 'Shovkat.jpg',
      },
      {
        text: 'Awesome courses. Simple and quite effective to learn data science. I recommend it to anyone who would like to learn data science from scratch.',
        name: 'soumyabrata roy',
        country: 'India',
        rating: 4.5,
        image: 'soumyabrata roy.jpg',
      },
      {
        text: '365 Data Science is really a complete package for the ones who love learning data science. In the course, you can learn data science from scratch, being taught easily and comprehensibly.',
        name: 'Ali Javid',
        country: 'Iran',
        rating: 4,
        image: 'Ali Javid.jpg',
      },
      {
        text: 'The 365 Data Science program was excellent. It does meet my expectations 100%. I do thank the 365 Data Science Team for putting this great work together in one package & with a very reasonable price. Hands down, you are...',
        name: 'Amrouni',
        country: 'France',
        rating: 5,
        image: 'Amrouni.jpg',
      },
      {
        text: 'I’m honestly impressed by the content and the way it’s delivered. If anybody would like to learn data science and other skills, here is the best platform which takes you from scratch to advanced level. The best part of this co...',
        name: 'Akhilesh Kumar',
        country: 'United States',
        rating: 4,
        image: 'Akhilesh Kumar.jpg',
      },
      {
        text: '365 Data Science offers courses that help you improve upon on your analytical knowledge with enough practical exercises. The program includes courses like Python for Finance, Customer Analytics, Time Series Analys...',
        name: 'Ayush Gujral',
        country: 'Pakistan',
        rating: 5,
        image: 'Ayush Gujral.jpg',
      },
      {
        text: 'From content to delivery mode, 365 Data Science courses have been structured in such a way to introduce the thinking behind the science and the tools. I particularly like the way 365 transitions from the background, basic...',
        name: 'Michael Ng\'ang\'a',
        country: 'Nigeria',
        rating: 4,
        image: 'Michael Ng\'ang\'a.jpg',
      },
    ],
  },

  fa: {
    row1: [
      {
        text: 'Great course. This course has helped me a lot in gaining knowledge in finance, accounting, business analysis, advanced MS excel, and PowerPoint. Highly recommended.',
        name: 'Snehadri N.',
        country: 'Myanmar',
        rating: 4,
        image: 'sn.jpg',
      },
      {
        text: 'Wow! This is exactly the kind of information I am looking for! Very detailed (which is very helpful!), engaging, polished, all-in-all makes for an amazing learning experience!',
        name: 'Juanita O.',
        country: 'Mexico',
        rating: 5,
        image: 'sm_juanita_o.jpg',
      },
      {
        text: 'Just a week into the training and learnt some new formulas in excel which I didn’t know existed until now. I am enjoying the accounting and financial modelling part. Overall the learning experience has been amazing..',
        name: 'Mohammed A.',
        country: 'Saudi Arabia',
        rating: 5,
        image: 'sm_mohammed_a.jpg',
      },
      {
        text: 'This is an amazing Course! Really helped me a lot. Learnt a lot of new things, using Excel like never before. Its a complete package of being interesting, keeping the person motivated and curious about what will come next, and being fun at the same time.',
        name: 'Sachin H.',
        country: 'Morocco',
        rating: 4,
        image: 'sm_sachin_h.jpg',
      },
      {
        text: 'I am new to finance, and this course gave me a wide variety of knowledge about many financial concepts out there. I recommend this course to everyone as anyone can follow along without prior knowledge.',
        name: 'Akshat J.',
        country: 'Egypt',
        rating: 5,
        image: 'sm_akshat-j.jpg',
      },
      {
        text: 'Amazing Course! The material is presented in a very easy to follow manner and is very detailed. Best Course out here for learning EXCEL skills in order to be a master financial analyst, and definitely worth the price!',
        name: 'Felicia W.',
        country: 'Germany',
        rating: 5,
        image: 'sm_felicia_w.jpg',
      },
      {
        text: 'My experience with this course has been really good. The course content was up to the mark. Multiple exercises were provided to get a grasp on Excel functions. I had a couple of doubts and got prompt replies from the instructor which helped me a lot. Overall, a great learning experience.',
        name: 'Poorva B.',
        country: 'India',
        rating: 4,
        image: 'pb.jpg',
      },
      {
        text: 'It has really helped me gain more knowledge on finances. It’s one of my best decision to take on this course, MUST TRY.....I do recommend it to check it out, it’s definitely going to help you out in the long run.',
        name: 'Ashley A.',
        country: 'United States',
        rating: 5,
        image: 'sm_ashley_a.jpg',
      },
      {
        text: 'This course is absolutely complete to make you an enviable staff with great skill in a typical finance and accounts department of any company. I always run back to it for refreshing my excel skills.',
        name: 'Daniel E.',
        country: 'United States',
        rating: 5,
        image: 'sm_daniel_e.jpg',
      },
      {
        text: 'Excellent course for a novice. Some issues require a more extensive explanation since a newbie will find it difficult to grasp in a single sitting. Its jam-packed with useful information.',
        name: 'Aniket G.',
        country: 'Nepal',
        rating: 4,
        image: 'sm_aniket_g.jpg',
      },
      {
        text: 'This an excellent course for anyone planning to pursue career in Finance domains, be it as an Analyst or Investment Banking. It explains all the concepts from very basics and has excellent notes in the course resources as well. The mentors even answer to the doubts in the QnA section, a rare thing to find on online mode of education.',
        name: 'Namita K.',
        country: 'India',
        rating: 5,
        image: 'nk.jpg',
      },
      {
        text: 'This is the best course a student aspiring to become a financial analyst can ask for. It covers all the basics, many advanced topics, and on top of all of that contains plenty of real time case studies. Most of all this is very affordable.',
        name: 'Dinesh K.',
        country: 'Bangladesh',
        rating: 5,
        image: 'sm_dinesh_k.jpg',
      },
      {
        text: 'All the financial aspects such as excel, accounting and finance are closely integrated. And, I can sense this early that, this is going to be a beautiful learning journey for me.',
        name: 'Aryan R.',
        country: 'France',
        rating: 5,
        image: 'sm_aryan_r.jpg',
      },
      {
        text: 'This course is really good and each concept is explained very clearly. Quiz at the end of all sections is also helpful in a way to get our concepts and application of functions more crystal clear.',
        name: 'Ayasha A.',
        country: 'United States',
        rating: 5,
        image: 'sm_ayasha_a.jpg',
      },
      {
        text: 'I have enjoyed learning accounting/finance concepts in this course. The instructor provided easy to understand examples that helped me understand the topics.',
        name: 'Ashley B.',
        country: 'Hungary',
        rating: 4,
        image: 'sm_ashley_b.jpg',
      },
      {
        text: 'Apart from learning excel and being a commerce student myself I never thought that accounting can be this interesting as Im not a number person. We were never given practical examples regarding all this at university as we have all the theoretical knowledge. Great Course',
        name: 'Kashish S.',
        country: 'Pakistan',
        rating: 5,
        image: 'ks.jpg',
      },
      {
        text: 'Really intuitive and engaging. Would highly recommend this course to graduates & working professionals who are looking for a deeper knowledge into financial analysis. Helps in honing your excel skills too!',
        name: 'Rajreet C.',
        country: 'India',
        rating: 5,
        image: 'rc.jpg',
      },
      {
        text: 'The course was very well structured and presented. The instructor broke down complex topics to a digestible and easy-to-understand manner. I especially enjoyed the tips & tricks information on the Microsoft Office tools as this was easily applicable in the real office world',
        name: 'Emmanuel M.',
        country: 'France',
        rating: 5,
        image: 'sm_emmanuel_m.jpg',
      },
      {
        text: 'Ive learned so much about business, company, and accounting through just one course. Its for those who wants to learn about finance from basic to advance.',
        name: 'Srikant P.',
        country: 'India',
        rating: 5,
        image: 'sm_srikant_p.jpg',
      },
      {
        text: 'I really didn’t have a financial background or even so much knowledge about it and this course has open my panorama and vision of the subject. Its an easy and practical way to start yourself in this market.',
        name: 'Luis Eduardo González D.',
        country: 'Spain',
        rating: 5,
        image: 'sm_luis eduardo gonzález_d.jpg',
      },
    ],
    row2: [
      {
        text: 'An excellent introduction to Investment Banking and a brief understanding of how a companys growth journey is from idea generation to a large enterprise.',
        name: 'Sandeep J.',
        country: 'india',
        rating: 4,
        image: 'sm_sandeep_j.jpg',
      },
      {
        text: 'Amazing course, one of the best (if not the best, in comparison to other courses of similar duration and complexity) out there to my knowledge, definitely would recommend.',
        name: 'Nikola J.',
        country: 'Hungary',
        rating: 5,
        image: 'sm_nikola_j.jpg',
      },
      {
        text: 'Was very good, they give a complete understanding theoretically as well as practically. Touches upon all necessary and related concepts very nicely.',
        name: 'Pavan',
        country: 'India',
        rating: 5,
        image: 'p.jpg',
      },
      {
        text: 'I didnt know anything about Investment Banking when I started this course. The course is structured in a very interesting and engaging way, that makes it easy to understand, and easy to remember. I highly recommend taking it as I now have a brilliant understanding of the Banking world.',
        name: 'Kian P.',
        country: 'Germany',
        rating: 5,
        image: 'sm_kian_p.jpg',
      },
      {
        text: 'Im an MBA student specializing in finance. Trust me, this course is teaching me IB better than what is taught in the physical course. Thank you!',
        name: 'Pratik K.',
        country: 'India',
        rating: 5,
        image: 'sm_pratik_k.jpg',
      },
      {
        text: 'Тhe learning thus far has been very good. Very good case studies and examples. Simple and concise resource materials and good explanations by the tutor.',
        name: 'Sobanjo O.',
        country: 'Malaysia',
        rating: 5,
        image: 'sm_sobanjo_o.jpg',
      },
      {
        text: 'This is an excellent course to understand the basics and foundations of the Investment Banking industry. It demystifies the notion that only a selected few highly gifted individuals can be part of this fraternity.',
        name: 'Sam B.',
        country: 'United States',
        rating: 4,
        image: 'sm_sam_b.jpg',
      },
      {
        text: 'Тhis course feel so great. I am a student on capital market majoring and I can say that everything that I learned in this course is very clear and easy to understand. Thank you!',
        name: 'Ahmad Abdullah A.',
        country: 'Morocco',
        rating: 5,
        image: 'aa.jpg',
      },
      {
        text: 'Im looking to bridge my knowledge as a Loan Officer to pivot into a position in securities. I believe this training course will position me for a job in the new field.',
        name: 'Audrey E.',
        country: 'United Kingdom',
        rating: 5,
        image: 'sm_audrey_e.jpg',
      },
      {
        text: 'Never had a more clear and comprehensive education on Investment Banking than through this course. I finally get it and I feel solidly ready for the field. Thank you!!',
        name: 'Johnny R.',
        country: 'United Kingdom',
        rating: 5,
        image: 'sm_johnny_r.jpg',
      },
      {
        text: 'I have attended many other classes on capital markets of IB, they made me sleepy. This course is pretty good; it has my attention and Im learning well.',
        name: 'Satabdi D.',
        country: 'Pakistan',
        rating: 4,
        image: 'sd.jpg',
      },
      {
        text: 'It induces the interest towards investment banking more and more. The video lectures are simply amazing and are above the expectation level.',
        name: 'Sanjhai P.',
        country: 'India',
        rating: 5,
        image: 'sm_sanjhai_p.jpg',
      },
      {
        text: 'Amazing breakdown! I really recommend that parents make high school students learn this content before they are in charge of their own finances!',
        name: 'Hannah D.',
        country: 'Switzerland',
        rating: 5,
        image: 'sm_hannah_d.jpg',
      },
      {
        text: 'Very good course and practical approach. This course covers theory and practical also. They ask you to value a company using excel sheet models. A perfect one if you want to learn basics of investment banking. I loved every bit of this course.',
        name: 'Aniket Jagannath T.',
        country: 'Thailand',
        rating: 4,
        image: 'sm_aniket_jagannath_t.jpg',
      },
      {
        text: 'The course is very enjoyable. Almost each issue is described and explained as it should be, so even if youre familiar with most of subject raised by the author, you still learn a lot of new things with a fresh look.',
        name: 'Szymon C.',
        country: 'Czech Republic',
        rating: 5,
        image: 'sm_szymon_c.jpg',
      },
      {
        text: 'The course was very informative and engaging. Definitely applaud the tutor for his great effort in explaining everything so clearly and simply. Ive become more interested in corporate finance since starting this course. Highly recommended!',
        name: 'Trang',
        country: 'Pakistan',
        rating: 5,
        image: 't.jpg',
      },
      {
        text: 'As a person with no background in the field, this course provided me with great insights into the industry and methods of work. It gives really good instruction on how to do hands on tasks related to the business evaluation. I find it useful and would recommend it to anyone.',
        name: 'Stefan R.',
        country: 'Slovakia',
        rating: 5,
        image: 'sm_stefan_r.jpg',
      },
      {
        text: 'Learned a lot about Capital Markets, Debt Offerings, Equity Offerings, Mergers and Acquisitions, Company Valuation, LBO modeling, and DCF Valuation, more and more value for money paid.',
        name: 'Abdul S.',
        country: 'Egypt',
        rating: 4,
        image: 'as.jpg',
      },
      {
        text: 'Great course. Starts from the basics for those with little or no experience but ends up going pretty deep in the concepts. Particularly liked the valuation and modeling part. It is hard to find courses that actually teach how to model an LBO.',
        name: 'Rodrigo Leitao Rodrigues D.',
        country: 'Columbia',
        rating: 5,
        image: 'sm_rodrigo_leitao_rodrigues_d.jpg',
      },
      {
        text: 'Fantastic course. Very interesting and comprehensive for someone like me with little to zero finance knowledge. The only improvement that I can suggest is to have more knowledge checks along the way for retention and validation.',
        name: 'Andrea Peralta I.',
        country: 'United States',
        rating: 5,
        image: 'sm_andrea-peralta-I.jpg',
      },
    ],
  },
};

export default {
  components: { SlidingAnimation, Rating, Check },
  props: {
    dark: { type: Boolean },
  },
  computed: {
    reviews() {
      return reviews;
    },
  },
};
</script>
<style lang="scss">
.reviews.slider {
  background-color: var(--main-light-shade-1);
  padding: var(--spacing-100) 0 var(--spacing-120);
  text-align: center;
  overflow: hidden;

  .h2 {
    margin-bottom: var(--spacing-36);
  }

  &.dark {
    background-color: var(--main-dark-shade-1);

    .h2 {
      color: var(--main-light);
    }

    .body-2 {
      color: var(--main-light-shade-3);
    }

    .reviews-animation .row .col .review {
      background-color: var(--main-dark-shade-2);
      color: var(--main-light);

      img {
        border-radius: 50%;
      }

      .info {
        div {
          color: rgba(255, 255, 255, 0.48);

          &.name {
            color: var(--main-light-shade-3);

            svg path[stroke] {
              stroke: var(--main-dark-shade-2);
            }
          }
        }
      }
    }
  }

  .reviews-animation {
    width: min-content;
    display: flex;

    >div {
      display: inline-block;
    }

    .row {
      flex-wrap: nowrap;
      margin-left: 0;
      margin-right: 0;

      &:first-child {
        margin-bottom: 20px;
        margin-left: -80px;
      }

      .col {
        max-height: 313px;
        box-sizing: unset;
        max-width: 380px;

        .review {
          height: 100%;
          width: 380px;
          background-color: var(--main-light);
          padding: 30px;
          box-shadow: 0 16px 30px rgba(0, 12, 31, 0.08);
          border-radius: 10px;
          text-align: left;
          transition: transform 0.8s, box-shadow 0.8s;
          cursor: default;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .rating {
            margin-bottom: var(--spacing-18);

            svg:not(.filled) path {
              fill: var(--main-light-shade-3);
              opacity: 1;
            }
          }

          .info {
            display: flex;
            margin-top: var(--spacing-24);
            align-items: center;

            img {
              width: 50px;
              height: 50px;
              margin-right: var(--spacing-16);
              border-radius: 50%;
            }

            div {
              color: var(--main-dark-shade-3);

              &.name {
                font-weight: 500;
                color: var(--main-dark-shade-0);
                display: flex;
                align-items: center;

                svg {
                  width: 20px;
                  margin-left: var(--spacing-8);
                }
              }
            }
          }
        }

        &:hover .review {
          transform: perspective(1px) scale(1.05);
          box-shadow: 0 12px 20px 0 rgba(0, 0, 50, 0.12);
        }
      }
    }
  }
}

.fa {
  .reviews.slider {
    .reviews-animation {
      .row {
        .col {
          max-height: 296px;

          .review {
            padding: var(--spacing-30) var(--spacing-30) var(--spacing-36);

            .body {
              .body-2 {
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 5;
                -webkit-box-orient: vertical;
                overflow: hidden;
              }
            }
          }
        }
      }
    }
  }
}

.name {
  &.fa {
    svg {
      path[fill] {
        fill: var(--accent);
      }
    }
  }
}

@include bp($bp-mobile) {
  .reviews.slider {
    overflow: hidden;
    padding-bottom: 80px;

    .animation {
      width: 1400px !important;
      height: 560px !important;
    }
  }

  .fa {
    .reviews.slider {
      .h2 {
        width: 80%;
        margin: 0 auto var(--spacing-36);
      }
    }
  }
}
</style>
